export default __webpack_public_path__ + "static/media/admin-icon.11816d46.jpg";